import { GoogleMapsAddressService } from '@df/module-google-maps/address/google-maps-address.service';
import { IAddressData } from '@df/session/api/address-book/address';
import { AddressFieldsetComponent } from '../../../common/address-fieldset/address-fieldset.component';

export class LocalGoogleMapsAddressService extends GoogleMapsAddressService {
    protected override applyAddressData(addressData: IAddressData, addressFieldsetComponent: AddressFieldsetComponent) {
        if (addressData?.street_2) {
            addressData.street_1 = [addressData.street_1, addressData.street_2].filter(i => !!i).join(' ');
            addressData.street_2 = undefined;
        }
        super.applyAddressData(addressData, addressFieldsetComponent);
    }
}
